import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const machineApi = createApi({
  reducerPath: "machineApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Machine"],
  endpoints: (builder) => ({
    getMachines: builder.query({
      query: (params = {}) => buildPagedListUrl("machine/", params),
      providesTags: ["Machine"],
    }),
    addMachine: builder.mutation({
      query: (newMachine) => ({
        url: "machine/",
        method: "POST",
        body: newMachine,
      }),
      invalidatesTags: ["Machine"],
    }),
    updateMachine: builder.mutation({
      query: ({ uid, ...updatedMachine }) => ({
        url: `machine/${uid}`,
        method: "PUT",
        body: updatedMachine,
      }),
      invalidatesTags: ["Machine"],
    }),
    deleteMachine: builder.mutation({
      query: (uid) => ({
        url: `machine/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Machine"],
    }),
  }),
});

export const {
  useGetMachinesQuery,
  useAddMachineMutation,
  useUpdateMachineMutation,
  useDeleteMachineMutation,
} = machineApi;
